import React, { useState } from 'react';
import SquareFootIcon from '@mui/icons-material/SquareFoot';
import Fade from '@mui/material/Fade';
import IconButton from '@mui/material/IconButton';
import Paper from '@mui/material/Paper';
import { useAtom } from 'jotai';
import PropTypes from 'prop-types';
import { isDrawingState } from '@/store';
import Measures from './Measures';
import styles from './MeasuresCtrl.module.scss';

export default function MeasuresCtrl({ map }) {
  const [isDrawing, setIsDrawing] = useAtom(isDrawingState);

  const [isOpen, setIsOpen] = useState(false);

  const onClick = () => {
    if (isDrawing) {
      setIsDrawing(false);
    }
    setIsOpen(!isOpen);
  };

  return (
    <>
      <Paper
        elevation={4}
        sx={{
          p: '2px',
        }}
      >
        <IconButton color="primary" aria-label="measures" title="Outil de mesure" onClick={onClick}>
          <SquareFootIcon />
        </IconButton>
      </Paper>
      <Fade in={isOpen}>
        <div className={styles.content}>
          <Measures map={map} />
        </div>
      </Fade>
    </>
  );
}

MeasuresCtrl.propTypes = {
  map: PropTypes.object.isRequired,
};
